var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14C17 14.5523 17.4477 15 18 15C18.5523 15 19 14.5523 19 14V13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H19V10C19 9.44772 18.5523 9 18 9C17.4477 9 17 9.44772 17 10V11H16C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13H17V14Z",
    fill: "#404D6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.5C4 5.0147 6.0147 3 8.5 3C10.9853 3 13 5.0147 13 7.5C13 9.9853 10.9853 12 8.5 12C6.0147 12 4 9.9853 4 7.5Z",
    fill: "#6B758B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18C2 15.9561 3.2284 14.1006 5.0625 13.3438C5.3183 13.2385 5.5919 13.2604 5.8438 13.375C6.7598 13.792 7.6248 14 8.5 14C9.3782 13.9998 10.2402 13.8028 11.125 13.4062C11.3806 13.292 11.6803 13.2954 11.9375 13.4062C13.7648 14.1937 15 16.0042 15 18V20C15 20.5523 14.5523 21 14 21H3C2.4477 21 2 20.5523 2 20V18Z",
    fill: "#6B758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendMenu);
export default __webpack_public_path__ + "static/media/Friend-menu.b45cdadeb0565213734649d81041d561.svg";
export { ForwardRef as ReactComponent };